<template>
  <!--优惠券列表-->
  <div class="ticket-list">
    <div class="top">
      <MHeader title="优惠券">
        <div slot="right" class="right" @click="isActivateShow = true">激活</div>
      </MHeader>
      <MNav
        @emit_changeTab="emit_changeTab"
        :ticketType="ticketType"
        :unUseCount="unUseCount"
        :usedCount="usedCount"
        :expireCount="expireCount"></MNav>
    </div>
    <!--<keep-alive>-->
      <!--<router-view :key="ticketType" @emit_setCount="emit_setCount" :ticketType="ticketType"></router-view>-->
    <!--</keep-alive>-->
    <keep-alive>
      <component
        :key="ticketType"
        @emit_setCount="emit_setCount"
        :refresh="refresh"
        :ticketType="ticketType"
        is="ScrollItem"></component>
      <!--<ScrollItem @emit_setCount="emit_setCount" :ticketType="1" v-if="ticketType === 1" :key="1"></ScrollItem>-->
      <!--<ScrollItem @emit_setCount="emit_setCount" :ticketType="2" v-if="ticketType === 2" :key="2"></ScrollItem>-->
      <!--<ScrollItem @emit_setCount="emit_setCount" :ticketType="3" v-if="ticketType === 3" :key="3"></ScrollItem>-->
    </keep-alive>

    <MActivate
      v-if="isActivateShow"
      @emit_close="emit_close"
      @emit_refresh="emit_refresh"></MActivate>
  </div>
</template>

<script>
  import MHeader from '@/components/MHeader';
  import MNav from '@/components/MNav';
  import MActivate from '@/components/MActivate';

  import ScrollItem from './components/ScrollItem';

  export default {
    name: 'index',
    components: {
      MHeader,
      MNav,
      MActivate,
      ScrollItem
    },
    data() {
      return {
        // currentIndex: 0,
        // 是否显示激活优惠券的对话框
        isActivateShow: false,
        // 过期的优惠券数量
        expireCount: 0,
        // 未使用的优惠券数量
        unUseCount: 0,
        // 已使用的优惠券数量
        usedCount: 0,
        unUseTicketList: [],
        usedTicketList: [],
        expireTocketList: [],
        // 优惠券类型，1:未使用 2:已使用 3:已失效，默认为未使用
        ticketType: 1,
        // 是否刷新子组件内容
        refresh: false
      };
    },
    mounted() {

    },
    methods: {
      emit_changeTab(index) {
        this.ticketType = index;
      },
      emit_close() {
        this.isActivateShow = false;
      },
      emit_setCount(counts) {
        Object.assign(this, counts);
      },
      // 激活优惠券后刷新未使用的优惠券页面
      emit_refresh() {
        const _this = this;
        _this.ticketType = 1;
        _this.$nextTick(() => {
          setTimeout(() => {
            _this.refresh = true;
            _this.$nextTick(() => {
              _this.refresh = false;
              _this.isActivateShow = false;
            });
          }, 500)
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.ticket-list {
  height: 100%;
  /*display: flex;*/
  /*flex-direction: column;*/
  .top {
    width: 100%;
    background-color: #fff;
  }
  .scroll-container {
    position: absolute;
    top: toRem(172);
    bottom: 0;
    background-color: #f5f5f5;
    overflow: hidden;
    width: 100%;
    padding: toRem(32) toRem(30) 0;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*align-items: flex-end;*/
    box-sizing: border-box;
    &.empty-container {
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/TicketList/index.vue